import { validateSetUserDisplayNameRequestPayload } from '@cascade/api-client/user';

export const { minLength: MIN_NAME_LENGTH, maxLength: MAX_NAME_LENGTH } =
  validateSetUserDisplayNameRequestPayload.limits.displayName;

export const isValidDisplayName = (name: string): boolean => {
  const details = validateSetUserDisplayNameRequestPayload({
    displayName: name,
  });

  return details.every(({ field }) => field !== 'displayName');
};

export const isSameDisplayName = (draft: string, saved: string): boolean =>
  draft.trim() === saved.trim();
